import {
  TRANSLATION_LOADING,
  TRANSLATION_ADD,
  TRANSLATION_DELETE,
  TRANSLATION_FILTERS,
  TRANSLATION_LIST,
} from "actions/translation/types";

const initialState = {
  loading: false,
  filters: {},
  list: {
    content: []
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TRANSLATION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case TRANSLATION_ADD:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.concat(action.payload)
        }
      };
    case TRANSLATION_DELETE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.filter(i => i.id !== action.payload.id)
        },
      };
    case TRANSLATION_FILTERS:
      return {
        ...state,
        loading: false,
        filters: action.payload
      };
    case TRANSLATION_LIST:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/translationReducer.js